import { useMemo } from 'react';
import { ChannelFaults } from './ChannelFaults';
import { FaultTextPresenter } from './FaultTextPresenter';
import { ChannelEditor } from '../../../../pages/EditController/SubPages/EditChannel/ChannelEditor';
import { getDisconnectedText } from './utils';
import { ICycleChannelCircleStateProps } from './types';
import { CycleCircleState } from './CycleCircleState';
import { useTranslation } from 'react-i18next';
import { CycleControllerFaultedPresenter } from './CycleControllerFaultedPresenter';

const ChannelFaultRouter = ({
  dcText,
  controllerFaulted,
  itemNum,
  controllerId,
  manualFaultMessage,
}: {
  dcText?: string;
  controllerFaulted: boolean;
  controllerId: string;
  itemNum: number;
  manualFaultMessage?: string;
}) => {
  const { t } = useTranslation();

  if (controllerFaulted) {
    return (
      <CycleControllerFaultedPresenter
        controllerId={controllerId}
        faultTitle={t('channels.faultsModal.title', '', { chNum: itemNum })}
      />
    );
  }

  if (dcText) {
    return <FaultTextPresenter faultText={dcText} title={t('channels.faultsModal.title', '', { chNum: itemNum })} />;
  }

  return <ChannelFaults channelNum={itemNum} controllerId={controllerId} manualFaultMessage={manualFaultMessage} />;
};

export const CycleChannelCircleState = (props: ICycleChannelCircleStateProps) => {
  const {
    itemNum,
    controllerId,
    controllerDisconnected,
    controllerFaulted,
    itemDisconnected,
    state,
    timestamp,
    manualFaultMessage,
  } = props;

  const { t } = useTranslation();

  const disconnectedText = useMemo(() => {
    return getDisconnectedText(controllerDisconnected, itemDisconnected);
  }, [itemDisconnected, controllerDisconnected]);

  const isFaulted = useMemo(() => {
    return !!disconnectedText || !!controllerFaulted
  }, [disconnectedText, controllerFaulted]);

  return (
    <CycleCircleState
      circleProps={{ timestamp, isFaulted, state }}
      modalTitle={t('terms.channel.numCName', '', { chNum: itemNum })}
      modalSize="fullscreen"
    >
      <div className="c-cycle-channel-circle-state flex w-full flex-col items-center gap-5">
        <div className="w-full max-w-screen-lg">
          <ChannelFaultRouter
            dcText={disconnectedText}
            controllerFaulted={controllerFaulted}
            controllerId={controllerId}
            itemNum={itemNum}
            manualFaultMessage={manualFaultMessage}
          />
        </div>
        <div className="w-full max-w-screen-lg">
          <ChannelEditor channel_number={itemNum} controllerId={controllerId} />
        </div>
      </div>
    </CycleCircleState>
  );
};
